import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MunicipioServices {
  private municipioApiUrl = `${environment.apiUrl}/municipio`;
  constructor(private http: HttpClient) {}

  crearMunicipio(municipio: any): Observable<any> {
    return this.http.post<any>(this.municipioApiUrl, municipio);
  }

  obtenerMunicipio(): Observable<any[]> {
    return this.http.get<any[]>(this.municipioApiUrl);
  }

  actualizarMunicipio(idMunicipio: string, municipio: any): Observable<any> {
    return this.http.patch<any>(`${this.municipioApiUrl}/${idMunicipio}`, municipio);
  }

  eliminarMunicipio(id: string): Observable<any> {
    return this.http.delete<any>(`${this.municipioApiUrl}/${id}`);
  }
}
